import { cn } from '@core/utils';

import { Image } from '@/components/client';

const COIN_SRC = {
  WELLO_POINT: '/assets/pngs/points/gold-coin.png',
  AFFILIATE_PARTNER_POINT: '/assets/pngs/points/partner-coin.png',
} as const;

interface PointCoinProps {
  currency: keyof typeof COIN_SRC;
  size: number;
  className?: string;
}

export const PointCoin = ({ currency, size, className }: PointCoinProps) => (
  <Image
    src={COIN_SRC[currency]}
    alt=""
    aria-hidden
    width={size}
    height={size}
    className={cn('shrink-0 object-contain', className)}
  />
);
